import api from '../../utils/api'

const API_BASE_URL = "/admin/ADPCust";

const ADPCustService = {
  async findAll(): Promise<any> {
    const response = await api.get(`${API_BASE_URL}/find-all`);
    return response.data;
  },

  async getItemById(customerCode: string): Promise<any> {
    const response = await api.get(`${API_BASE_URL}/find-one/${customerCode}`);
    return response.data;
  },

  async create(item: any): Promise<any> {
    const response = await api.post(`${API_BASE_URL}/create`, item);
    return response.data;
  },

  async update(customerCode: string, item: any): Promise<any> {
    const response = await api.put(`${API_BASE_URL}/update/${customerCode}`, item);
    return response.data;
  },

  async delete(customerCode: string): Promise<any> {
    const response = await api.delete(`${API_BASE_URL}/delete/${customerCode}`);
    return response.data;
  },

  async getDropdownByCustomerType(customerType: any): Promise<any> {
    const response = await api.get(`${API_BASE_URL}/get-dropdown-by-customer-type/${customerType}`);
    return response.data;
},

};

export default ADPCustService;